import React from 'react';

import { SkeletonImage, SkeletonBody } from '@xingternal/skeleton';

import styles from './Skeleton.css';

const AboutUsSkeleton = () => (
  <div className={styles.aboutUsWrapper} data-testid="aboutus-skeleton">
    <SkeletonImage variant="primary" size="medium" className={styles.image} />
    <div className={styles.summary}>
      <SkeletonBody variant="primary" amountRows={4} />
    </div>
  </div>
);

export default AboutUsSkeleton;
